import {
  AfterViewInit,
  ChangeDetectorRef,
  Component, ElementRef, HostListener,
  OnInit,
  QueryList,
  ViewChildren
} from '@angular/core';
import {HomeContent} from "../../interfaces/home-content";
import {UiHelperService} from "../../services/ui-helper.service";
import {DisplayService} from "../../services/display.service";

@Component({
  selector: 'brt-logo-slider',
  templateUrl: './logo-slider.component.html',
  styleUrls: ['./logo-slider.component.scss']
})
export class LogoSliderComponent implements OnInit, AfterViewInit {

  // @Input("home-content") set setHomeContent(value: HomeContent) {
  //   this.homeContent = value;
  // };
  @HostListener('window:resize', ['$event'])
  onResize($event: Event) {
    if(this.logoImagesElements?.length) {
      const isMobile = this.displayService.isMobileScreenSize();
      const scale = isMobile ? 0.5 * 0.7 : 0.5;

      this.logoImagesElements.forEach((el) => {
        this.setImageWidth(el.nativeElement as HTMLImageElement, scale);
      })
    }

  }

  @ViewChildren('logoImage') set setLogoImages(val: QueryList<ElementRef>) {
    if(val.length) {
      this.logoImagesElements = val;
      val.forEach((el) => {
        const imgElement = el.nativeElement as HTMLImageElement;
        imgElement.onload = ($event) => {
          const isMobile = this.displayService.isMobileScreenSize();
          const scale = isMobile ? 0.5 * 0.7 : 0.5;
          this.setImageWidth(imgElement, scale);
        }
      })
    }
  }

  logoImagesElements!: QueryList<ElementRef>;

  logos: string[][] = [
    ["3_planlicht_logo_schwarz-auf-weissen-Hintergrund.png", "3_planlicht_logo_schwarz-auf-weissen-Hintergrund"],
    ["12CB9EFE-68D1-470C-847E-9374D7F9D733.png", "12CB9EFE-68D1-470C-847E-9374D7F9D733"],
    ["6791d9ab1eb3fedc49538170d3d396ac146de2c6.png", "6791d9ab1eb3fedc49538170d3d396ac146de2c6"],
    ["220330_RZ_UllaPopken_LOGO_02_Two-Lines_black.png", "220330_RZ_UllaPopken_LOGO_02_Two-Lines_black"],
    ["AGEtech-Logo.png", "AGEtech-Logo"],
    ["ATT.png", "ATT"],
    ["Auto Paulweber.png", "Auto_Paulweber"],
    ["Autohaus Wolf.png", "Autohaus_Wolf"],
    ["BBS_Logo_regular_CMYK_POS.png", "BBS_Logo_regular_CMYK_POS"],
    ["BC_Logo 1.png", "BC_Logo_1"],
    ["Bergzeit.png", "Bergzeit"],
    ["Blattl-Logo.png", "Blattl-Logo"],
    ["blue tomato.png", "blue_tomato"],
    ["Blumen Calovini.png", "Blumen_Calovini"],
    ["BMF_Finanzamt_Oesterreich_Logo.png", "BMF_Finanzamt_Oesterreich_Logo"],
    ["Bodner Bau.png", "Bodner_Bau"],
    ["Daimler-Truck_Logo.png", "Daimler-Truck_Logo"],
    ["Deichmann.png", "Deichmann"],
    ["Die Malerie.png", "Die_Malerie"],
    ["dummy-logo-plasee.png", "dummy-logo-plasee"],
    ["dummy-logo-swarovski.png", "dummy-logo-swarovski"],
    ["dummy-logo-tirol-kliniken.png", "dummy-logo-tirol-kliniken"],
    ["Dunkin_PrimaryWordmark_2color_RGB.png", "Dunkin_PrimaryWordmark_2color_RGB"],
    ["Ebene_1.png", "Ebene_1"],
    ["eder.png", "eder"],
    ["ela_logo_positiv_RGB.png", "ela_logo_positiv_RGB"],
    ["Equans-Logo.png", "Equans-Logo"],
    ["Erlebnis Sennerei Zillertal.png", "Erlebnis_Sennerei_Zillertal"],
    ["Finum-Private-Finance_grey-transparent.png", "Finum-Private-Finance_grey-transparent"],
    ["Firma_square.png", "Firma_square"],
    ["Forcher-Logo-Mit-Adler-oben-mitte-schwarz.png", "Forcher-Logo-Mit-Adler-oben-mitte-schwarz"],
    ["Frame.png", "Frame"],
    ["Frame-1.png", "Frame-1"],
    ["Frame-2.png", "Frame-2"],
    ["Fred's Malerei.png", "Fred's_Malerei"],
    ["Gannomat_Logo_1000x241px_300dpi_v1.png", "Gannomat_Logo_1000x241px_300dpi_v1"],
    ["Group.png", "Group"],
    ["GUG-LOGO-CLAIM.png", "GUG-LOGO-CLAIM"],
    ["GW_cube_orange_PNG_5253.png", "GW_cube_orange_PNG_5253"],
    ["Hagleitner.png", "Hagleitner"],
    ["Haller.png", "Haller"],
    ["Happy-Fitness-Logo-Outline-new.png", "Happy-Fitness-Logo-Outline-new"],
    ["Hussl-Logo-neu.png", "Hussl-Logo-neu"],
    ["image 1.png", "image_1"],
    ["image 2.png", "image_2"],
    ["image 3.png", "image_3"],
    ["image 4.png", "image_4"],
    ["image 5.png", "image_5"],
    ["image 6.png", "image_6"],
    ["image 7.png", "image_7"],
    ["image 8.png", "image_8"],
    ["image 9.png", "image_9"],
    ["image 10.png", "image_10"],
    ["image 11.png", "image_11"],
    ["INTERSPORT-Kaltenbrunner-ohne-Filialen.png", "INTERSPORT-Kaltenbrunner-ohne-Filialen"],
    ["Kirschl.png", "Kirschl"],
    ["Loacker.png", "Loacker"],
    ["Logo-2.png", "Logo-2"],
    ["logo-autopark-at-3.png", "logo-autopark-at-3"],
    ["Logo-BMT.png", "Logo-BMT"],
    ["LOGO-Einwaller-Fahion-Stores-Innsbruck-Altstadt.png", "LOGO-Einwaller-Fahion-Stores-Innsbruck-Altstadt"],
    ["Logo-farbig.png", "Logo-farbig"],
    ["Logo-Fifex.png", "Logo-Fifex"],
    ["logo-JYSK-jpg-2.png", "logo-JYSK-jpg-2"],
    ["Logo-NYer-ohne-Claim-2.png", "Logo-NYer-ohne-Claim-2"],
    ["Logo-Oberland-Reutte-pos-2c.png", "Logo-Oberland-Reutte-pos-2c"],
    ["Logo-Schalber_5sterneS_4c.png", "Logo-Schalber_5sterneS_4c"],
    ["Logo-Wilten-Final-17.png", "Logo-Wilten-Final-17"],
    ["Logo_DAS-SIEBEN.png", "Logo_DAS-SIEBEN"],
    ["Logo_Frauenschuh_elefant.png", "Logo_Frauenschuh_elefant"],
    ["Logo_Garzaner.png", "Logo_Garzaner"],
    ["Logo_Justiz2023.png", "Logo_Justiz2023"],
    ["logo_kitzspitz_braun_gross-1.png", "logo_kitzspitz_braun_gross-1"],
    ["LOGO_SKODA_GROUP_A.png", "LOGO_SKODA_GROUP_A"],
    ["MicrosoftTeams-image-1.png", "MicrosoftTeams-image-1"],
    ["MR-Dachmarkenlogo-4c_ohneProfis_gross.png", "MR-Dachmarkenlogo-4c_ohneProfis_gross"],
    ["neues-Logo2023.png", "neues-Logo2023"],
    ["Neutral-ohne-Gewerke-Logo.png", "Neutral-ohne-Gewerke-Logo"],
    ["nextro.png", "nextro"],
    ["nordpan_Logo_CMYK.png", "nordpan_Logo_CMYK"],
    ["OeBB_rgb226-0-42-brief_2019.png", "OeBB_rgb226-0-42-brief_2019"],
    ["PR_Walchsee_Sportresort.png", "PR_Walchsee_Sportresort"],
    ["Renault-Logo-2021.png", "Renault-Logo-2021"],
    ["seiwald_logo_CMKY_4c.png", "seiwald_logo_CMKY_4c"],
    ["SPAR-3.png", "SPAR-3"],
    ["Stadtwerke Kufstein.png", "Stadtwerke_Kufstein"],
    ["SWA_Wordmark_rgb_black_JPG_2021.png", "SWA_Wordmark_rgb_black_JPG_2021"],
    ["Tchibo-Eduscho_Logo-hor_Gold-dark_sRGB-1.png", "Tchibo-Eduscho_Logo-hor_Gold-dark_sRGB-1"],
    ["TIQU_Logo_Flat_CMYK.png", "TIQU_Logo_Flat_CMYK"],
    ["Tom-Tailor-Logo-1.png", "Tom-Tailor-Logo-1"],
    ["TUI_3CPM_tileblue.png", "TUI_3CPM_tileblue"],
    ["TUIBLUE_A3CPM.png", "TUIBLUE_A3CPM"],
    ["Wammes_4c.png", "Wammes_4c"],
    ["Würth.png", "Würth"]
  ]

  randomLogos: string[][] = [];

  // homeContent!: HomeContent;

  currentSlide = 1;

  constructor(private cdRef: ChangeDetectorRef, private uiHelper: UiHelperService, private displayService: DisplayService) {
  }

  ngOnInit() {
    const maxLogos = 15;
    const shuffledLogos = this.logos.sort(() => 0.5 - Math.random());
    this.randomLogos = shuffledLogos.slice(0, maxLogos);
  }

  ngAfterViewInit() {

  }

  setImageWidth(image: HTMLImageElement, scale: number) {
    const width = image.naturalWidth;
    image.style.width = this.uiHelper.getScaledPixel(width * scale) + 'px';
  }
}
